import autobind from "autobind-decorator";
import {
  BaseballStore,
  BasketballStore,
  BetbleLiveStore,
  FootballStore,
  HockeyStore,
  LolStore,
  MajorStore,
  ProtoStore,
  SoccerStore,
  StarcraftStore,
  VolleyballStore,
} from "routes/score/store";
import { computed, observable } from "mobx";
import { ScoreService } from "services";
import { asyncAction } from "mobx-utils";

@autobind
class ScoreStore {
  constructor(stores) {
    this.major = new MajorStore(this);
    this.soccer = new SoccerStore(this);
    this.baseball = new BaseballStore(this);
    this.basketball = new BasketballStore(this);
    this.volleyball = new VolleyballStore(this);
    this.hockey = new HockeyStore(this);
    this.football = new FootballStore(this);
    this.lol = new LolStore(this);
    this.starcraft = new StarcraftStore(this);
    this.proto = new ProtoStore(this);
    this.betbleLive = new BetbleLiveStore(this);
  }

  @observable
  calendarGameCount = [];

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get gameCount() {
    return this.calendarGameCount.toJS();
  }

  /**********************************************************
   * async actions
   **********************************************************/
  @asyncAction
  async *requestGetCalender(sportsType, month, year) {
    try {
      this.calendarGameCount = yield ScoreService.getGameCountCalendar(
        sportsType,
        month,
        year
      );
    } catch (error) {
      console.log(error);
    }
  }
}

export default ScoreStore;
